import { Button, Link, Typography } from '@mui/material';
import SummarizeIcon from '@mui/icons-material/Summarize';
import useStyles from './useStyles';
import { useNavigate } from 'react-router-dom';
import DownloadProfilesExcel from '../../common/downloadProfilesExcel';
import translate from '../../i18n/translate';
import ProfilesDataGrid from '../UI/ProfilesDataGrid';
import { useEffect, useState } from 'react';
import { userApi } from '../../modules/services/userService';

const ProfilesScreen = () => {
  const classes = useStyles();
  const navigate = useNavigate()
  const [profileType, setProfileType] = useState<string>('all')
  const profileTypes = [
    {
      key: 'all',
      title: translate('profilesAllProfiles')
    },
    {
      key: 'deleted',
      title: translate('profilesDeletedProfiles')
    },
  ]

  function handleDownload(){
    DownloadProfilesExcel("he")
  }

  const { data: totalCreditsCount, refetch } = userApi.useGetRobotSmsTotalCreditsQuery('');

  useEffect(() => {
    setTimeout(() => {
      refetch();
    }, 60000)
  }, [refetch])

  return(
      <div className={classes.Wrapper}>
            <div className={classes.StatusesList}>
              <Link 
              color="#fc7f03" 
              className={classes.ToMain} 
              mr={10} 
              ml="10px" 
              onClick={()=>navigate("/")}>
                {translate('commonBackToTheMainPage')}
              </Link>
              {profileTypes.map((item, index)=>(
                <Link 
                key={index} 
                mr={2} 
                style={{
                  cursor: "pointer",
                  color: "#fc7f03",
                  textDecorationColor: "#fc7f03",
                  textDecoration: item.key === profileType ? 'underline' : "none",
                  fontSize: "20px",
                }} 
                onClick={()=>setProfileType(item.key)}>
                  {item.title}
                </Link>
              ))}
              <div/>
              <Typography sx={{ marginInlineStart: '20px' }} fontSize={18} color='#fc7f03'>
                {translate('profilesTotalCreditsCountL')}
                &nbsp;
                <b>
                  {totalCreditsCount}
                </b>
              </Typography>
              <Button 
              sx={{
                color: "black", 
                marginLeft: "150px"
              }} 
              startIcon={<SummarizeIcon sx={{color: "black"}}/>}
              onClick={()=>handleDownload()}
              >
                {translate("buttonDownloadAllInformation")}
              </Button>
          </div>
          <ProfilesDataGrid type={profileType}/>
      </div>
  )
}

export default ProfilesScreen;